<template>
    <div class="wrap-document">
        <div class="page">
            <p class="title">SURAT PERNYATAAN</p>
            <div class="content">
                <p>Saya yang bertandatangan di bawah ini:</p>
                <div class="format-text"><label>Nama</label> : {{ dataPrint.fullname }}</div>
                <div class="format-text"><label>NIK</label> : {{ dataPrint.ktp }}</div>
                <form>
                    <div class="form-group"></div>
                </form>
            </div>
            <div class="content">
                Dengan ini menyatakan dengan sesungguhnya, bahwa nama yang tercantum dalam Akun Perdagangan Perdagangan Berjangka ini adalah untuk dan atas nama diri
                saya sendiri dan tidak untuk orang lain. Dan saya bertanggung jawab penuh atas penggunaan Akun Perdagangan Perdagangan Berjangka ini.
                <form>
                    <div class="form-group"></div>
                </form>
            </div>
            <div class="persetujuan">
                <div></div>
                <div class="ttd">
                    <div>{{ dataPrint.tempat_ttd }}, {{ currentDate | formatDateTime }}</div>
                    <div class="jabatan">
                        <p class="tanggal">Yang membuat pernyataaan</p>
                        <img :src="dataPrint.tandaTangan" alt="" class="tanda-tangan" />
                        <p class="format-text">{{ dataPrint.fullname }}</p>
                    </div>
                </div>
            </div>
            <!-- <div class="persetujuan">
        <p class="tanggal">Yang membuat pernyataaan</p>
        <div class="jabatan">
          <p></p>
          <p></p>
        </div>
        <div>
          <p></p>
          <img :src="dataPrint.tandaTangan" alt="" class="tanda-tangan" />
        </div>
        <div>
          <p></p>
          <p class="format-text">{{ dataPrint.fullname }}</p>
        </div>
      </div> -->
            <!-- <div class="footer">
                <p>Investor Management System</p>
                <p>1</p>
                <p>Printed @ {{ currentDate | formatDate }}</p>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fullName: String,
        dataPrint: Object,
    },
    data() {
        return {
            currentDate: "",
        };
    },
    mounted() {
        this.currentDate = new Date();
    },
};
</script>

<style scoped>
label {
    width: 100px;
}
/* .page {
    padding: 2rem;
} */

.page {
    padding: 1cm;
    /* border: 5px red solid; */
    /* height: 257mm; */
    /* outline: 2cm #FFFFFF solid; */
}

.wrap-document {
    /* width: 210mm; */
    min-height: 277mm;
    /* padding: 10mm; */
    margin: 0.5mm auto;
    /* border: 1px #d3d3d3 solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.format-text {
    text-transform: capitalize;
}

.format-text::first-letter,
.format-text::first-line {
    text-transform: capitalize;
}

.tanda-tangan {
    width: 80%;
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    margin-block-end: 40px;
    font-size: 14px;
}

.content {
    font-size: 12px;
    text-align: justify;
}

.sub-content {
    font-weight: 700;
}

form {
    margin: 20px 0;
    text-align: right;
    font-weight: 700;
}

label {
    margin-right: 15px;
}

.penutup {
    text-align: center;
    font-size: 12px;
}

.penutup p {
    margin: 0;
}

.resiko {
    font-weight: 700;
}

.persetujuan {
    /* width: 60%; */
    font-size: 12px;
    margin: 30px 0 90px;
    display: flex;
    justify-content: space-between;
}

.persetujuan .ttd {
    width: 30%;
    text-align: center;
}

.tanggal {
    margin-left: auto;
    margin-bottom: 10px !important;
}

.jabatan {
    margin-bottom: 70px !important;
}

.pt-abi {
    display: block !important;
    margin: 20px auto;
    width: 50%;
}

.pt-abi p {
    width: auto !important;
}

.footer {
    display: flex;
    font-size: 10px;
    justify-content: space-between;
    position: absolute;
    width: 80%;
    bottom: 0;
}

@page {
    size: A4;
    margin: 0;
}

@media (max-width: 768px) {
    .page {
        padding: 0;
    }

    .title {
        margin: 20px auto !important;
    }
}
</style>
